export type GateState = { gain: number; hold: number; opened?: boolean };
export type GateOptions = { enabled: boolean; threshold: number; gain: number };
export const clamp = (value: number, min: number, max: number) => Math.max(min, Math.min(max, value));

export function processGate(input: Float32Array, output: Float32Array, state: GateState, options: GateOptions, rate: number) {
  let power = 0;
  for (const sample of input) power += sample * sample;
  const rms = Math.sqrt(power / Math.max(1, input.length));
  const threshold = 10 ** (clamp(options.threshold, -65, -25) / 20);
  // A lower closing threshold keeps quiet syllables from repeatedly opening/closing.
  if (rms >= threshold || (state.opened && rms >= threshold * 0.5)) state.hold = Math.round(rate * 0.2);
  const open = !options.enabled || rms >= threshold || state.hold > 0;
  state.opened = options.enabled && open;
  const target = open ? 1 : 0;
  const smoothing = Math.exp(-1 / (rate * (open ? 0.008 : 0.12)));
  const trim = clamp(options.gain, 0, 150) / 100;
  let peak = 0;
  for (let index = 0; index < output.length; index++) {
    state.gain = target + smoothing * (state.gain - target);
    const sample = (input[index] ?? 0) * state.gain * trim;
    peak = Math.max(peak, Math.abs(sample));
    output[index] = Math.abs(sample) <= 0.95 ? sample : Math.sign(sample) * (0.95 + 0.05 * Math.tanh((Math.abs(sample) - 0.95) / 0.05));
  }
  state.hold = Math.max(0, state.hold - output.length);
  return { db: Math.max(-100, 20 * Math.log10(Math.max(rms, 0.00001))), peak, open: state.gain > 0.1 };
}
